var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(this.$store.state.auth.role,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }